
<v-app :style="`background: ${appBackground}`">
  <ReloadPrompt />
  <!-- GlobalSnackbar must mount unconditionally so $refs.snackbar is set up
       in App's mounted() hook regardless of staging-gate state. -->
  <GlobalSnackbarVue ref="snackbar" />
  <OnlineStatus />
  <!-- BUG-CL-001 fix: when the staging-password gate is active, suppress the
       rest of the app chrome (navbar, router-view, footer) so the staging
       dialog is the only thing on screen — previously the login dialog (on
       /ucc-login) mounted underneath, creating two overlapping modals that
       shared the same backdrop. -->
  <template v-if="!mStagingCredentials">
    <PublicNavBar v-if="!isAuthenticated" />
    <ForceLogoutModal />
    <v-main>
      <v-container :fluid="$vuetify.breakpoint.mdAndDown">
        <router-view />
      </v-container>
    </v-main>
    <PublicFooter v-if="!isAuthenticated" />
  </template>
  <v-dialog
    transition="dialog-top-transition"
    max-width="600"
    persistent
    :value="mStagingCredentials"
    aria-label="UCC staging password verification"
  >
    <v-card>
      <v-toolbar color="primary" dark class="px-3 title"
        ><span id="staging-credentials-title">Verification</span></v-toolbar
      >
      <v-layout column class="pa-8 pb-0">
        <label class="title pb-3" for="staging-credentials-input"
          >UCC Staging Password</label
        >
        <v-text-field
          id="staging-credentials-input"
          outlined
          class="my-3"
          type="password"
          label="Enter Password"
          v-model="stagingCredentials"
          :error-messages="stagingCredentialsError"
        />
      </v-layout>
      <v-card-actions class="justify-end px-6 pb-5 pt-0">
        <v-btn
          :disabled="stagingCredentials.length === 0"
          color="primary"
          @click="verifyStagingCredentials"
          >Verify</v-btn
        >
      </v-card-actions>
    </v-card>
  </v-dialog>
</v-app>
